import React from 'react';
interface VimeoBackgroundProps {
  iframeId?: string;
}
export function VimeoBackground({
  iframeId = 'vimeo-bg'
}: VimeoBackgroundProps) {
  return <div className="absolute inset-0 z-0 overflow-hidden bg-obsidian pointer-events-none" data-id="element-89">
      <div className="absolute top-1/2 left-1/2 w-[100vw] h-[56.25vw] min-h-[100vh] min-w-[177.77vh] -translate-x-1/2 -translate-y-1/2" data-id="element-90">
        <iframe id={iframeId} src="https://player.vimeo.com/video/1171062669?autoplay=1&muted=1&loop=1&controls=0&title=0&byline=0&portrait=0&dnt=1&quality=1080p&api=1" className="absolute top-0 left-0 w-full h-full border-0" allow="autoplay; fullscreen; picture-in-picture" title="The Doors of Perception Background" data-id="element-91" />
      </div>

      {/* Dark gradient overlay for text readability and cinematic feel */}
      <div className="absolute inset-0 bg-gradient-to-b from-obsidian/80 via-transparent to-obsidian/90" data-id="element-92" />
      <div className="absolute inset-0 bg-obsidian/20" data-id="element-93" />
    </div>;
}